import { AdminApi } from 'stylemix-vue-admin'

export default class CurrenciesApi extends AdminApi {
  constructor(parameters) {
    super('currencies', parameters)
  }

  setDefault(currency) {
    return this.submit('POST', `${this.endpoint}/default/${currency}`)
  }
}
